export const styles = {
    PaddingT:'sm:pt-12 pt-6',
    PaddingX:'sm:px-16 px-6',
    DisplayBetween:'flex  justify-between items-center',
    DisplayStart:'flex justify-center items-center',
    container:'xl:max-w-[2800px] w-full',

}